'use client'

import { type ReactNode, useEffect, useRef, useState } from 'react'

interface ImageLoadStateProps {
  children: ReactNode
  placeHolder: ReactNode
}

export const ImageLoadState = ({ children, placeHolder }: ImageLoadStateProps) => {
  const rootRef = useRef<HTMLSpanElement>(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const image = rootRef.current?.querySelector('img')
    if (!image) {
      setLoaded(true)
      return
    }

    if (image.complete) {
      setLoaded(true)
      return
    }

    const finish = () => setLoaded(true)
    image.addEventListener('load', finish)
    image.addEventListener('error', finish)
    const timeout = setTimeout(finish, 5000)

    return () => {
      image.removeEventListener('load', finish)
      image.removeEventListener('error', finish)
      clearTimeout(timeout)
    }
  }, [])

  return (
    <span ref={rootRef} className="contents" data-image-load-state={loaded ? 'loaded' : 'loading'}>
      {children}
      {!loaded ? placeHolder : null}
    </span>
  )
}
